import { useEffect } from 'react'
import { Helmet } from 'react-helmet'

// auth
import { authClient } from '../auth'

export const AdminLoginPage = () => {
  useEffect(() => {
    authClient.login()
  }, [])

  return (
    <>
      <Helmet>
        <title>POAP - Login</title>
        <meta property="og:title" content="POAP - Login" />
      </Helmet>
    </>
  )
}
